import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"

export class FirestoreUser {

    public displayName: string|undefined = undefined
    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public email: string|undefined = undefined
    public roles: string[]|undefined = undefined
    public updateTimestamp: Date|undefined = undefined
    public creationDate: Date|undefined = undefined
    public firstName: string|undefined = undefined; // Vorname; Firstname
    public lastName: string|undefined = undefined; // Nachname; Lastname
    public gender?: string|undefined = undefined;// (m / f / d) // (m / w / d)
    public salutation?: string|undefined = undefined; // Anrede, Salutation
    public title?: string|undefined = undefined;; // Titel; title
    public legalAddress?:IFirestoreUserLegalAdress |undefined = undefined;
    public telephone?: string |undefined = undefined;
    public signature?: string |undefined = undefined;
    public invitationState?: string|undefined = undefined;
    public language ?:string|undefined = undefined
    public oobCode ?: string | undefined = undefined
    public contextMembership?: any |  undefined = undefined
    public contextIds?:string[] | undefined = undefined
    public userGroupIds?:string[] | undefined = undefined
    public selectedContextId?: string |undefined = undefined
    constructor() {}

    setFromAny(element: any) {
        const {
            displayName, 
            identifier,
            contextId,
            email,
            roles,
            updateTimestamp, 
            creationDate,
            firstName,
            lastName,
            gender,
            salutation,
            title,
            legalAddress,
            telephone,
            signature,
            invitationState,
            language,
            oobCode,
            contextMembership,
            contextIds,
            userGroupIds,
            selectedContextId
        } = element

        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.email = email ?? this.email
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.roles = roles ?? this.roles
        this.displayName = displayName ?? this.displayName
        this.firstName = firstName ? firstName : this.firstName
        this.lastName = lastName ? lastName : this.lastName
        this.gender = gender ? gender : this.gender
        this.salutation = salutation  ? salutation : this.salutation
        this.title = title ? title : this.title
        this.legalAddress = legalAddress ? legalAddress : this.legalAddress
        this.telephone = telephone ? telephone : this.telephone
        this.signature = signature ? signature : this.signature
        this.invitationState = invitationState ? invitationState : this.invitationState
        this.language = language ? language : this.language
        this.oobCode  = oobCode ? oobCode : this.oobCode
        this.contextMembership = contextMembership ? contextMembership : undefined
        this.contextIds = contextIds ? contextIds : undefined
        this.userGroupIds = userGroupIds ? userGroupIds : undefined
        this.selectedContextId = selectedContextId ? selectedContextId : undefined
    }

    public static setFromAny(element: any): FirestoreUser {
        const user = new FirestoreUser()
        user.setFromAny(element)
        return user
    }

    searchFilter(filter: string): boolean {
        const str = `${this.displayName}${this.email}`.toLowerCase()
        return str.includes(filter)
    }

    public toString(): string {
        return JSON.stringify(this)
    }
}

export class FirestoreInviteUser {
    public language: string|undefined = undefined
    public email: string|undefined = undefined
    public roles: string[]|undefined = undefined
    public contextId?: string|undefined = undefined
    public displayName?: string|undefined = undefined
    public updateTimestamp?: Date|undefined = undefined
    public creationDate?: Date|undefined = undefined
    public invitationState?: string|undefined = undefined
    public registrationLink?: string|undefined = undefined
    public oobCode?: string|undefined = undefined
    public identifier?: string|undefined = undefined
    constructor() {}

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            email,
            roles,
            updateTimestamp, 
            creationDate,
           
        } = element

        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.email = email ?? this.email
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
        this.roles = roles ?? this.roles
    }

    public static setFromAny(element: any): FirestoreInviteUser {
        const user = new FirestoreInviteUser()
        user.setFromAny(element)
        return user
    }

    // searchFilter(filter: string): boolean {
    //     const str = `${this.displayName}${this.email}`.toLowerCase()
    //     return str.includes(filter)
    // }

    public toString(): string {
        return JSON.stringify(this)
    }
}

export enum UserRoles {
    ANSTELLER = "ansteller",
    JAGDLEITER = "jagdleiter",
    USER = "user",
    HUNTER = "hunter",
    REVIERLEITER = "revierLeiter",
    RECORDER = "recorder",
    APPVET = "applicantVet",
    VETHDLEADER = "veterinaryHuntingDistrictLeader",
    ADMIN = "admin",
    CADAVERSEEK = "wsvgKadaverSucher",
    CADAVERBT = "wsvgKadaverBergeTeam",
    STAFF = "wsvgSonstigerMitarbeiter",
    SENIOR = "wsvgLeitenderMitarbeiter"
}

export interface IFirestoreUserLegalAdress {
    address1?: String; // Adresse; Address 
    address2?: String; // Adresszusatz; Address suffix
    zip?: String; // Postleitzahl; Postcode
    city?: String; // Stadt; City
    country?: String; // Land; Country
    countryCode?:string
}
export interface IFirestoreUser {
    email: string;
    password: string;
    roles: string[];
    displayName: string;
    contextId?: string;
    firstName: String; // Vorname; Firstname
    lastName: String; // Nachname; Lastname
    gender?: String;// (m / f / d) // (m / w / d)
    salutation?: String; // Anrede, Salutation
    title?: String; // Titel; title
    legalAddress?:IFirestoreUserLegalAdress;
    telephone?: String;
    signature?: String; // should be editable only for own user
    invitationState?: string;
    language?:String;
    oobCode?:string
    selectedContextId?:string
}

export interface IFirestoreInviteUser {
    email: string;
    contextId?: string;
    roles?: string[];
    displayName?: string
    invitationState?: string
    registrationLink?: string
    creationDate?: any
    oobCode?: string
    language: string // "de" or "en"!
    identifier?:string
}